<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  const dispatch = createEventDispatcher();

  export let modalTarget: string;
  export let modalType: string = 'modal-lg';

  let modalElement: any;

  onMount(() => {
    if (modalTarget) {
      modalElement = document.getElementById(modalTarget);

      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', handleModalClose);
      }
    }
  });

  onDestroy(() => {
    if (modalElement) {
      modalElement.removeEventListener('hidden.bs.modal', handleModalClose);
    }
  });

  function handleModalClose() {
    dispatch('modalClose');
  }
</script>

<div class="modal fade" id={modalTarget} tabindex="-1" aria-hidden="true">
  <div class="modal-dialog {modalType} modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <slot name="modal-title"></slot>
      </div>

      <div class="modal-body">
        <slot name="modal-body"></slot>
      </div>

      <div class="modal-footer">
        <slot name="modal-footer"></slot>
      </div>
    </div>
  </div>
</div>

<style>
  .modal-header .btn-close {
    position: absolute;
    margin: 0;
    padding: 0;
  }
</style>
